import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useEffect, useState } from "react";
import { changePasswordCall } from "../../api/api";
import Modal from "../../components/modal";

export default function ChangePassword({ open, onClose }) {
  const [state, setState] = useState({
    currentPassword: "",
    newPassword: "",
    newPasswordRepeat: "",
  });
  const onSubmit = async () => {
    if (!state.currentPassword) {
      return global.showAlert(
        "Validation Errors",
        "Current password is required to change the password",
        "warning"
      );
    } else if (!state.newPassword) {
      return global.showAlert(
        "Validation Errors",
        "New password is required to change the password",
        "warning"
      );
    } else if (!state.newPasswordRepeat) {
      return global.showAlert("Validation Errors", "Please re-enter the new password.", "warning");
    } else if (state.newPassword !== state.newPasswordRepeat) {
      return global.showAlert(
        "Validation Errors",
        "Re-entered password not matching with the new password",
        "warning"
      );
    } else {
      const user = await changePasswordCall({
        currentPassword: state.currentPassword,
        newPassword: state.newPassword,
      });
      if (user) {
        global.showAlert("Change Password Success", "", "success");
        onClose();
      }
    }
  };

  useEffect(() => {
    setState({
      currentPassword: "",
      newPassword: "",
      newPasswordRepeat: "",
    });
  }, [open]);

  return (
    <Modal
      open={open}
      title={"Change password"}
      actions={
        <MDBox display={"flex"} gap={1} justifyContent="right">
          <MDButton onClick={onSubmit} variant="gradient" color="info">
            submit
          </MDButton>
          <MDButton onClick={onClose} variant="gradient" color="error">
            cancel
          </MDButton>
        </MDBox>
      }
    >
      <MDBox component="form" role="form">
        <MDBox mb={2}>
          <MDInput
            type="password"
            label="Current Password"
            fullWidth
            value={state.currentPassword}
            onChange={(event) => {
              setState({ ...state, currentPassword: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="password"
            label="New Password"
            fullWidth
            value={state.newPassword}
            onChange={(event) => {
              setState({ ...state, newPassword: event.target.value });
            }}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            type="password"
            label="Repeat New Password"
            fullWidth
            value={state.newPasswordRepeat}
            onChange={(event) => {
              setState({ ...state, newPasswordRepeat: event.target.value });
            }}
          />
        </MDBox>
      </MDBox>
    </Modal>
  );
}
